/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/**
 * Converts id from the GraphQL UUID format to the dbId format,
 * for example: 'Program:1' to '1'.
 */
export const uuidToDbId = (uuid: string): string => uuid.split(':')[1];
